import { useAddFavouriteMutation, useRemoveFavouriteMutation } from 'generated/graphql';
import { useRouter } from 'next/router';
import useUser from 'stores/useCustomer';
import useProtectClient from './useProtectFunction';
import { useSignOut } from './useSignOut';
import { useNavigation } from './useNavigation';

export default function useCustomerActions() {
    const protect = useProtectClient();
    const toggleFavouriteState = useUser((state) => state.toggleFavourite);
    const { asPath: currentPage, push } = useRouter();
    const [addFavouriteMutation] = useAddFavouriteMutation();
    const [removeFavouriteMutation] = useRemoveFavouriteMutation();
    const signOut = useSignOut();

    const {
        shop,
        myCustomers,
        myAccount,
    } = useNavigation();

    const toggleFavourite = (productId: number) => {
        if (!protect(undefined, 'not-authenticated.favourites')) return;
        const { addedFavourite } = toggleFavouriteState(productId);
        if (addedFavourite) {
            addFavouriteMutation({
                variables: { productId },
                refetchQueries: ['getFavourites'],
            });

            return;
        }
        removeFavouriteMutation({
            variables: { productId },
            refetchQueries: ['getFavourites'],
        });
    };

    const clickMyPersonalWebshopHome = () => (
        push(shop.home)
    );

    const clickFavourites = () => (
        push(shop.favourites)
    );

    const clickMyCustomersHome = () => (
        push(myCustomers.home)
    );

    const clickMyAccount = () => (
        push(myAccount.settings)
    );

    const clickMyCustomersSettings = () => (
        push(myCustomers.settings)
    );

    const clickLogOut = () => (
        signOut(currentPage)
    );

    return {
        clickMyPersonalWebshopHome,
        clickMyCustomersHome,
        clickMyCustomersSettings,
        clickFavourites,
        clickMyAccount,
        clickLogOut,
        toggleFavourite,
    };
}
